import MicroModal from 'micromodal';

export default function () {
    const widgetName = 'microModalFeature';
    const widgetOpts = microModalFeatureOpts;

    // Content options-------------
    const widgetImage = true; // False > will remove local theme logo .


    // Storage selector-------------
    const sectionTrigger = "homepage";
    const cookiesTimeStamp = 1;


    const alwaysShowPopUp = false; // Disable checkbox and always shows pop up
    const checkboxModal = false; // Enable checkbox and checks conditions

    const buttonText = "Continue"; // Button text
    const targetBlankUrl = false; // alt attribute


    return saffire.widgets.cardWidget($(`#${widgetName}`), {
        currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

        cardWidgetLoaded: function (data) {

            let statusPopUp = data.items.length;

            if (statusPopUp > 0) {

                const d = data.items[0];
                const title = d.Title == null ? "" : `<h2 class="modal__title" id="modal-title">${d.Title}</h2>`;
                const description = d.Description == null ? "" : `<p class="modal__description">${d.Description}</p>`;
                const img = !d.ImageWithPath ? "" : widgetImage ? `<div class="modal__content-left"><img src="${!(d.ImageWithPath) ? "" : d.ImageWithPath}"></div>` : '';

                const url = d.URL == null ? "" : `<a href="${d.URL}" class="button" ${targetBlankUrl ? 'target="_blank"' : ''}>${buttonText}</a>`;

                const checkboxOption = alwaysShowPopUp ? "" : (checkboxModal ? (`<div class="checkbox"><input type='checkbox' id='removePopUp'/><label for="removePopUp">Don't show this message in the future</label></div>`) : "");


                function initializePopupModal() {
                    // FORM LAYOUT-------------
                    $('body').append(`
                <div class="micromodal-slide" id="modal" aria-hidden="true">
                  <div class="modal__overlay" tabindex="-1">
                    <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                      <label class="modal-close-btn" data-micromodal-close>X</label>
                        <header class="modal__header"></header>
                      <div class="modal__content" id="modal-content">
                        ${img}
                        <div class="modal__content-right ${!d.ImageWithPath ? 'imagesAlignment' : ' noImagesAlignment'}">
                          ${title}
                          ${description}
                          ${url}
                          ${checkboxOption}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `);

                    MicroModal.show('modal');
                }

                if ($('body').hasClass(sectionTrigger)) { // To be triggered on homepage/any other page

                    if (alwaysShowPopUp) { // if value is true, it will always show the pop up
                        initializePopupModal();

                    } else { // if variable is false

                        if (navigator.cookieEnabled) { // if cookies are enabled

                            if (Cookies.get('modalCookie')) { // if there's already a cookie, it wont show the pop up
                                return false;
                            } else {
                                if (localStorage.getItem('modalLocal') == 'true') { // if user already set to not show pop up again (checjbox)
                                    return false;
                                } else {
                                    initializePopupModal();
                                    Cookies.set('modalCookie', 'modalCookie', { expires: cookiesTimeStamp }); // set the cookie
                                }
                            }

                        } else { // if cookies are disabled

                            if (sessionStorage.getItem('modalSession')) { // get session item, if there's an item, it wont show pop up
                                return false;
                            } else {
                                if (localStorage.getItem('modalLocal') == 'true') { // if theres an item, it will check for a local item. if theres an item, it wont show pop up (handled by checkbox)
                                    return false;
                                } else { // if theres no item on local, it will show the pop up and set session item
                                    initializePopupModal();
                                    sessionStorage.setItem('modalSession', true);
                                }
                            }
                        }
                    }

                } else {
                    return false;
                }


                // Checkbox setting to remove/add cookie-------------
                $('#removePopUp').on('change', function () {
                    if ($(this).is(':checked')) {
                        localStorage.setItem('modalLocal', true)
                    } else {
                        localStorage.setItem('modalLocal', false)
                    }
                });
            }


        },

        itemsPerPanel: 1,
        link: [],
        maxItemsVisible: 1,
        scriptPath: widgetOpts.scriptPath,
        showDescription: true,

    });
}